import { render } from "./ListSection.vue?vue&type=template&id=32065504"
import script from "./ListSection.vue?vue&type=script&lang=js"
export * from "./ListSection.vue?vue&type=script&lang=js"

import "./ListSection.vue?vue&type=style&index=0&id=32065504&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__